import { Injectable } from '@angular/core';
import { LoadingController, Events } from 'ionic-angular';

import { EVT_SESSION_EXPIRED } from '../../constants';

@Injectable()
export class LoadingProvider {

  private _loader = null;

  constructor(
    private events: Events,
    private loadingCtrl: LoadingController)
  {
    this.events.subscribe(EVT_SESSION_EXPIRED, () => {
      this._safeDismiss();
    });
  }

  present(content = "", dismissOnPageChange = false): void {
    this._safeDismiss();

    this._loader = this.loadingCtrl.create({
      content: content,
      dismissOnPageChange: dismissOnPageChange,
    });

    this._loader.present();
  }

  dismiss(): void {
    this._safeDismiss();
  }

  private _safeDismiss(): void {
    if (!this._loader) return;
    const loader = this._loader;
    this._loader = null;
    try {
      const result = loader.dismiss();
      if (result && typeof result.catch === "function") {
        result.catch(() => {});
      }
    } catch (e) {
      // el loader ya fue removido, ignorar
    }
  }

  setContent(newContent: string): void {
    if (this._loader)
      this._loader.setContent(newContent);
  }
}



// WEBPACK FOOTER //
// ./src/providers/loading/loading.ts